import React from 'react';
import AddModule from './AddModule';
import ListeModule from './ListeModule';
import MyCard from '../../../../components/Common/MyCard';

const Module = () => {
    return (
        <div>
            <MyCard
                titleCard="Module"
                addComponent={<AddModule />}
                content={<ListeModule /> }
            />
        </div>
    );
}

export default Module;
